/**
 * both Thrive and Cognito API error payloads will have a `code` and `message`
 */

export class ApiError extends Error {
  message: string
  code: string

  constructor(arg: { message: string; code: string }) {
    super(arg.message)
    this.message = arg.message
    this.code = arg.code

    // restore prototype chain
    const actualProto = new.target.prototype
    Object.setPrototypeOf(this, actualProto)
  }
}
